import ShiritoriLogoPath from '../assets/image/shiritori-main.webp';
import { Link, Outlet } from 'react-router-dom';
import { ReturnButton } from '../components/home/buttons';
import { useTranslation } from 'react-i18next';

export function HomeView() {
    const { t } = useTranslation();

    return (
        <div className="h-full">
            <div className="h-1/2 mx-auto w-60 md:w-80 flex flex-col justify-center">
                <div className="relative">
                    <ReturnButton />
                    <h1 aria-level={1} className="w-full animate-puff-in-center">
                        <Link to="/" className="">
                            <img src={ShiritoriLogoPath} alt={t('common.txtLogoAlt')} className="w-full h-full drop-shadow-heavy object-contain" />
                        </Link>
                    </h1>
                </div>
            </div>
            <div className="mx-auto h-1/3 w-60 md:w-80 py-2">
                <Outlet />
            </div>
        </div>
    );
}
